import React from 'react';

import {
    Box,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Container,
    Heading,
} from '@chakra-ui/react';
import { PrismicRichText } from '@prismicio/react';

export default function AccordionSlice({ slice }) {
    console.log(slice)
    return (
        <Container as="section" maxW="container.xl" my="8">
            <Accordion allowToggle>
                {slice.items.map((item, index) => (
                    <AccordionItem key={index}>
                            <AccordionButton>
                                <Box flex="1" textAlign="left">
                                    <Heading as="h3" variant="h3" fontSize="1.5rem">
                                        {item.panel_title}
                                    </Heading>
                                </Box>
                                <AccordionIcon />
                            </AccordionButton>
                        <AccordionPanel pb={4}>
                            <PrismicRichText 
                                field={item.panel_content.richText} />
                        </AccordionPanel>
                    </AccordionItem>
                ))}
            </Accordion>
        </Container>
    )
}